import { Button } from '@/components/ui/button';
import { useDetectiveTourStore } from '@/store/detectiveTourStore';

/**
 * Header launch button for the guided tour. Sits beside "Ask AI" and matches
 * its `Button` idiom (outline at rest, filled while running).
 *
 * The label collapses to the emoji on narrow screens so the header still fits
 * alongside the search box and account menu.
 */
export default function DetectiveTourButton(): JSX.Element {
  const active = useDetectiveTourStore((s) => s.active);
  const start = useDetectiveTourStore((s) => s.start);
  const exit = useDetectiveTourStore((s) => s.exit);

  return (
    <Button
      variant={active ? 'default' : 'outline'}
      size="sm"
      onClick={active ? exit : start}
      aria-label={active ? 'Exit the guided tour' : 'Run the Detective guided tour'}
    >
      <span aria-hidden className="mr-0 sm:mr-2">
        🕵️
      </span>
      <span className="hidden sm:inline">
        {active ? 'Exit tour' : 'Run the Detective'}
      </span>
    </Button>
  );
}
